/**
 * Blog header: categories dropdown (mobile/tablet) with a nested, single-open
 * accordion for parent categories.
 */
function init($) {
    var $wraps = $('[data-blog-dropdown]');
    if (!$wraps.length) { return; }

    $wraps.each(function () {
        var $wrap   = $(this);
        var $toggle = $wrap.find('.blog-header__dropdown-toggle');

        $toggle.on('click', function (e) {
            e.stopPropagation();
            var isOpen = $wrap.hasClass('is-open');
            $wrap.toggleClass('is-open', !isOpen);
            $toggle.attr('aria-expanded', String(!isOpen));
        });

        // Nested accordion: expand/collapse a parent category's children.
        // Single-open — opening one branch collapses the others.
        $wrap.find('.blog-header__dropdown-parent').on('click', function (e) {
            e.stopPropagation();
            var $parent = $(this);
            var $group  = $parent.closest('[data-blog-subgroup]');
            var willExpand = !$group.hasClass('is-expanded');

            $wrap.find('[data-blog-subgroup]').not($group)
                .removeClass('is-expanded')
                .find('.blog-header__dropdown-parent').attr('aria-expanded', 'false');

            $group.toggleClass('is-expanded', willExpand);
            $parent.attr('aria-expanded', String(willExpand));
        });

        // Close on Escape, restoring focus to the toggle
        $wrap.on('keydown', function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                $wrap.removeClass('is-open');
                $toggle.attr('aria-expanded', 'false');
                $toggle.trigger('focus');
            }
        });
    });

    // One outside-click handler closes any open dropdown (bound once, not per-wrap).
    $(document).on('click', function (e) {
        $wraps.each(function () {
            var $wrap = $(this);
            if (!$wrap.is(e.target) && $wrap.has(e.target).length === 0) {
                $wrap.removeClass('is-open');
                $wrap.find('.blog-header__dropdown-toggle').attr('aria-expanded', 'false');
            }
        });
    });
}

module.exports = { init };
